<template>
  <div class="ma-2">
    <v-card
      v-if="
        checkaccessdata.is_viewer == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat v-else>
      <OverleyProccessg :overlay="overlay" />
      <v-card class="mt-5">
        <v-data-table
          class="mt-5"
          :headers="headers"
          item-key="fund_id"
          dense
          :items="itemapprove"
          :loading="loading"
          :no-data-text="Nodata"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="getApporveHistoryPagination()"
        >
          <!-- show-select
        :single-select="singleSelect"
        v-model="selected" -->

          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ itemapprove.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <span class="caption"
              ><b>{{ item.name }}</b></span
            ><br />
            <span class="caption">{{ item.mobile_number }}</span>
          </template>
          <template v-slot:[`item.department_name`]="{ item }">
            <span class="caption">{{ item.department_name }}</span>
          </template>
          <template v-slot:[`item.card_balance`]="{ item }">
            <span class="caption">{{ item.card_balance }}</span>
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span class="caption"
              ><b>{{ item.amount }}</b></span
            >
          </template>
          <template v-slot:[`item.initiated_by`]="{ item }">
            <span class="caption">{{ item.initiated_by }}</span>
          </template>
          <template v-slot:[`item.initiated_from`]="{ item }">
            <span class="caption">{{ item.initiated_from }}</span>
          </template>
          <template v-slot:[`item.initiated_on`]="{ item }">
            <span class="caption">{{ item.initiated_on }}</span>
          </template>
          <template v-slot:[`item.fund_details.initiated_from`]="{ item }">
            <span class="caption">{{ item.fund_details.initiated_from }}</span>
            <br />
            <span class="caption" v-if="item.load_type == 1"
              ><b>Load Cards</b></span
            >
            <span class="caption" v-if="item.load_type == 2"
              ><b>Unload Cards</b></span
            >
          </template>

          <template v-slot:[`item.comments`]="{ item }">
            <v-tooltip color="primary" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="orange"
                  v-if="item.comments != null"
                  >mdi-message-text</v-icon
                >
                <!-- v-if="item.nymcard_status.length > 0" -->
              </template>

              <span class="">
                {{ item.comments }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.requested_from`]="{ item }">
            <div v-if="item.requested_from == '1'">
              <span v-on="on" class="caption">APP </span>
            </div>
            <div v-if="item.requested_from == '2'">
              <span v-on="on" class="caption">CORPORATE </span>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-icon
            v-if="checkaccessdata.is_approver == true"
              @click="showContent(item)"
              small
              class="mr-2"
              color="primary"
              >mdi-eye</v-icon
            >
          </template>

          <template v-slot:[`item.status_value`]="{ item }">
            <div v-if="item.status == '1'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING
                  </span>
                </template>
                <span>PENDING</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '2'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption green--text font-weight-medium"
                    >FUND APPROVED</span
                  >
                </template>
                <span>FUND APPROVED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '3'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption red--text font-weight-medium"
                    >FUND REJECTED</span
                  >
                </template>
                <span>FUND REJECTED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '5'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PARTIALLY APPROVED</span
                  >
                </template>
                <span>PARTIALLY APPROVED</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:top>
            <v-row class="ml-2">
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-select
                  label="Load Type"
                  outlined
                  class="mt-4"
                  dense
                  item-text="name"
                  item-value="value"
                  v-model="cardtype"
                  :items="cardtypes"
                ></v-select>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogStart"
                  v-model="modalStart"
                  :return-value.sync="start_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="start_date"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mt-4"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    scrollable
                    :max="currentDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="
                        setMinMaxToDate();
                        $refs.dialogStart.save(start_date);
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="end_date"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mt-4"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    scrollable
                    :max="maxEndDate"
                    :min="start_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-text-field
                  v-model="search"
                  color="primary"
                  shaped
                  outlined
                  dense
                  class="mt-4"
                  clearable
                  label="Search"
                  single-line
                  :hint="searchint"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
                <v-btn
                  small
                  fab
                  text
                  @click="getApporveHistory"
                  color="dark"
                  class="elevation-0 mt-4 mr-2"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn></v-col
              >
              <v-spacer />
            </v-row>

            <!-- v-if="viewdetailsarray.length != 0" -->
            <v-row class="mt-n1">
              <v-spacer></v-spacer>
              <v-col
                cols="12"
                lg="3"
                xl="3"
                md="3"
                sm="12"
                xs="12"
                v-if="itemapprove.length > 0"
              >
                <v-chip class="mt-n2 ml-0 mb-3" color="primary" outlined label>
                  <span class="green--text subtitle-2">
                    <b class="primary--text">Corporate Balance :</b>
                    MYR {{ fundingBalance }}
                  </span>
                </v-chip>
              </v-col>

              <!-- <v-col cols="3" md="2" class="mr-10">
                <v-btn color="primary" outlined small>
                  <span class="red--text subtitle-2">
                    <b class="primary--text">Debit Amount :</b>
                    MYR {{ debitAmount }}
                  </span>
                </v-btn>
              </v-col> -->
            </v-row>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="showcommStatus" width="900" persistent>
        <v-card width="900" class="overflow-hidden">
          <v-toolbar flat class="header" dense dark>
            <v-icon>mdi-cash-multiple</v-icon>
            <span class="ml-3">
              Fund Details of {{ commentsDetails.name }} - {{ LoadCards }}</span
            >
            <!-- <span v-if="loadType == 1" class="ml-3"
              >Fund Details of {{ commentsDetails.name }}</span
            >
            <span v-if="loadType == 2" class="ml-3"
              >Unload Cards For {{ commentsDetails.name }}</span
            > -->
            <v-spacer></v-spacer>
            <v-btn class text dark @click="closedialog()">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-row class="ml-2 mr-2 mt-3">
            <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
              <v-text-field
                v-model="commentsDetails.corp_balance"
                label="CORPORATE BALANCE"
                class="cursor red--text"
                rounded
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
              <v-text-field
                v-model="commentsDetails.opening_balance"
                label="OLD CARD BALANCE "
                class="cursor white--text"
                rounded
                readonly
                color="primary"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
              <v-text-field
                v-model="commentsDetails.amount"
                label="REQUESTED AMOUNT"
                class="cursor white--text"
                rounded
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
              <v-text-field
                v-model="commentsDetails.closing_balance"
                label="NEW CARD BALANCE"
                class="cursor white--text"
                rounded
                readonly
                color="primary"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-n5 ml-7">
            <v-col
              cols="12"
              lg="12"
              xl="12"
              md="12"
              sm="12"
              xs="12"
              class="red--text ml-n4 mt-n6"
              v-if="
                Number(commentsDetails.corp_balance) <
                  Number(commentsDetails.amount) &&
                this.commentsDetails.load_type == 1
              "
            >
              <b style="font-size: 15px">
                Your Corporate Balance is Less than Requested Amount !! Please
                Fund Your Corporate Account.
                <v-btn
                  class="primary--text cursors"
                  @click="addfundtoaccount()"
                  text
                  ><u>Click here</u></v-btn
                ></b
              >
            </v-col>
          </v-row>
          <v-divider class="mt-3"></v-divider> <br />

          <v-row class="mt-n8 ml-2 mr-2">
            <v-col cols="12" lg="6" xl="6" md="6" sm="12" xs="12">
              <p class="subtitle-2 mt-3">
                <b class="primary--text">INITIATED FROM:</b>
                {{ InitiatedFrom }}
              </p>
              <br />

              <p class="subtitle-2 mt-n8">
                <b class="primary--text">INITIATED BY:</b>
                {{ initiatedby }}
              </p>
              <br />

              <p class="subtitle-2 mt-n8">
                <b class="primary--text">INITIATED ON:</b>
                {{ initiatedon }}
              </p>
              <br />
            </v-col>
            <v-col
              cols="12"
              lg="5"
              xl="5"
              md="5"
              sm="12"
              xs="12"
              v-if="urlimage.length != 0"
            >
              <v-card-actions class="mt-3">
                <v-avatar
                  v-for="(item, i) in urlimage"
                  :key="i"
                  size="40"
                  :class="{ 'ma-3': i }"
                  tile
                >
                  <v-icon
                    v-if="item.includes('webp' || 'WEBP')"
                    size="46"
                    color="primary"
                    @click="openImageInNewTab(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('jpg' || 'JPG')"
                    size="46"
                    color="primary"
                    @click="openImageInNewTab(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('jpeg' || 'JPEG')"
                    size="46"
                    color="primary"
                    @click="openImageInNewTab(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('png' || 'PNG')"
                    size="46"
                    color="primary"
                    @click="openImageInNewTab(item)"
                    >mdi-image</v-icon
                  >
                  <v-icon
                    v-if="item.includes('docx' || 'doc')"
                    size="44"
                    color="blue"
                    @click="openImageInNewTab(item)"
                    >mdi-file-word</v-icon
                  >
                  <v-icon
                    v-if="item.includes('txt')"
                    size="44"
                    color="blue"
                    @click="openImageInNewTab(item)"
                    >mdi-file-document</v-icon
                  >
                  <v-icon
                    v-if="item.includes('pdf')"
                    size="44"
                    color="red"
                    @click="openImageInNewTab(item)"
                    class="ml-3"
                    >mdi-file-pdf</v-icon
                  >

                  <v-icon
                    v-if="item.includes('xls' || 'xlsx')"
                    size="44"
                    color="green"
                    @click="openImageInNewTab(item)"
                    >mdi-file-excel</v-icon
                  >
                </v-avatar>
              </v-card-actions>
            </v-col>
          </v-row>
          <v-divider class="mt-n8"></v-divider><br />

          <v-row class="mt-n2 ml-2 mr-2">
            <v-col cols="12" md="6">
              <p class="subtitle-1 mt-n4">
                <b class="gold--text">DEPARTMENT DETAILS</b>
              </p>
              <br />

              <p class="subtitle-2 mt-n8">
                <b class="primary--text"> NAME :</b>
                {{ commentsDetails.department_name }}
              </p>
              <br />
              <p class="subtitle-2 mt-n8">
                <b class="primary--text"> BUDGET :</b>
                MYR {{ commentsDetails.department_budget }}
              </p>
              <br />
              <p class="subtitle-2 mt-n8">
                <b class="primary--text">USER BUDGET :</b>
                MYR {{ commentsDetails.user_budget }}
              </p>
              <br />
              <p class="subtitle-2 mt-n8">
                <b class="primary--text">ALLOCATED :</b>
                MYR {{ commentsDetails.allocated_budget }}
              </p>
              <br />
              <p class="subtitle-2 mt-n8">
                <b class="primary--text">UNALLOCATED :</b>
                MYR {{ commentsDetails.unallocated_budget }}
              </p>

              <br />
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mt-n4">
                <b class="gold--text">FUND DETAILS</b>
              </p>
              <br />
              <p class="subtitle-2 mt-n8">
                <b class="primary--text">FUND TITLE :</b>
                {{ commentsDetails.fund_title }}
              </p>
              <br />

              <p class="subtitle-2 mt-n8">
                <b class="primary--text">USER COMMENTS :</b>
                {{ commentsDetails.comments }}
              </p>
            </v-col>
          </v-row>
          <v-row class="mt-n4 ml-2 mr-2">
            <v-col
              cols="12"
              flat
              v-if="
                Number(commentsDetails.unallocated_budget) <
                  Number(commentsDetails.amount) ||
                (Number(commentsDetails.user_budget) <
                  Number(commentsDetails.amount) &&
                  this.commentsDetails.load_type == 1)
              "
            >
              <b style="font-size: 15px" class="red--text"
                >Requested Amount is more than User Budget/Unallocated
                Budget!!</b
              >
            </v-col>
          </v-row>
          <v-row class="mt-n2 ml-2 mr-2">
            <v-col cols="12" md="4">
              <v-text-field
                @keypress="isNumber(event)"
                label="Approve Amount(MYR)"
                v-model="approve_amount"
                :hint="max_amount"
                outlined
                :color="redcolor"
                :error="error"
                required
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-form ref="approveform">
                <v-textarea
                  outlined
                  :rules="nameRules"
                  dense
                  rows="1"
                  label="Comment"
                  v-model="approvercomment"
                  auto-grow
                ></v-textarea>
              </v-form>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              v-if="commentsDetails.status == '1'"
              rounded
              color="red"
              class="mt-n4 ml-3 white--text"
              @click="confirmApproveRejectdialog()"
              >Reject</v-btn
            >
            <!-- @click="approveFund('3', commentsDetails)" -->
            <v-btn
              v-if="commentsDetails.status == '1'"
              rounded
              :disabled="
                (Number(commentsDetails.corp_balance) <
                  Number(approve_amount) &&
                  this.commentsDetails.load_type == 1) ||
                (Number(commentsDetails.opening_balance) <
                  Number(approve_amount) &&
                  this.commentsDetails.load_type == 2)
              "
              color="green "
              class="mt-n4 ml-3 white--text"
              :rules="remarkRule"
              @click="approveFund()"
              >Approve</v-btn
            >
            <!-- @click="approveFund('2', commentsDetails)" -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog class="overflow-hidden" v-model="arraylistStatus" width="600">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-file-image</v-icon>
          <span class="ml-3">Receipt </span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="arraylistStatus = false">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-carousel hide-delimiters>
            <v-carousel-item
              v-for="(item, i) in urlimage"
              :key="i"
              :src="item"
              @click="openinWindow(item)"
            ></v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
      <v-dialog v-model="verifyOtpDialog" width="600">
        <v-card>
          <v-card-text class="pt-6 black--text subtitle-1">
            <v-form ref="otpform" v-model="otpvalid" lazy-validation>
              <v-row align="center" justify="center">
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="one"
                />
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  @keypress="isNumber($event)"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="two"
                />
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  @keypress="isNumber($event)"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="three"
                />
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  @keypress="isNumber($event)"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="four"
                />
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  @keypress="isNumber($event)"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="five"
                />
                <input
                  v-on:input="$event.target.nextElementSibling.focus()"
                  @keypress="isNumber($event)"
                  type="text"
                  maxlength="1"
                  size="1"
                  min="0"
                  max="9"
                  pattern="[0-9]{1}"
                  v-model="six"
                />
              </v-row>
            </v-form>
            <v-row align="center" justify="center" class="mt-3">
              <v-col md="9">
                <v-btn
                  outlined
                  color="primary"
                  block
                  @click="verifyOtpApproval()"
                  >VERIFY</v-btn
                >
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <span class="grey--text caption">OTP has been sent to </span>
            </v-row>
            <v-row align="center" justify="center">
              <span class="grey--text caption">
                {{ this.$store.getters.get_getCustDetails.mobile_num }}</span
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmApproveRejectDialog" width="400" persistent>
        <v-card class="overflow-hidden">
          <v-toolbar class="elevation-0" dense>
            <span> Are you sure you want to reject ? </span>
            <v-spacer></v-spacer>
            <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
          </v-toolbar>
          <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-row class="mt-2" style="margin-left: 200px">
              <v-btn
                text
                width="90px"
                class="mb-4 red--text"
                @click="confirmApproveRejectDialog = false"
                >Back</v-btn
              >
              <v-btn
                text
                width="90px"
                class="mb-4 primary--text"
                @click="confirmApproveReject('3')"
                >Submit</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
import moment from "moment";

export default {
  components: { OverleyProccessg },
  data: () => ({
    showcommStatus: false,
    confirmApproveRejectDialog: false,
    one: "",
    two: "",
    three: "",
    loading: false,
    four: "",

    five: "",
    six: "",
    otp: "",
    verifyOtpDialog: false,
    cardtype: 0,
    cardtypes: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "Load Cards",
        value: 1,
      },
      {
        name: "Unload Cards",
        value: 2,
      },
    ],
    otpvalid: true,
    approve_amount: "",
    max_amount: "",
    overlay: false,
    commentsDetails: "",
    dialogcondition: false,
    itemapprove: [],
    remarkRule: [(v) => !!v || "Required"],
    selected: [],
    imageurl: [],
    nameRules: [(v) => !!v || "Required",
    (v) => /^[a-zA-Z0-9 .,-/]+$/.test(v) || "Invalid Character found",
    ],
    approvercomment: "",
    total: "",
    InitiatedFrom: "",
    initiatedon: "",
    singleSelect: true,
    headers: [
      { text: "SL NO", value: "sl_no", sortable: false },

      {
        text: "CARD USER",
        value: "name",
        sortable: false,
      },
      // {
      //   text: "Proxy Number",
      //   value: "proxy",
      // },
      {
        text: "DEPARTMENT",
        value: "department_name",
        sortable: false,
      },
      {
        text: "REQUESTED FROM",
        value: "fund_details.initiated_from",
        sortable: false,
      },
      // {
      //   text: "LOAD TYPE",
      //   value: "load_type",
      //   sortable: false,
      // },

      // {
      //   text: "CARD BALANCE(MYR)",
      //   value: "card_balance",
      //   sortable: false,
      // },
      {
        text: "CREATED ON",
        value: "created_on",
        sortable: false,
      },
      {
        text: "REQUESTED AMOUNT(MYR)",
        value: "amount",

        sortable: false,
      },
      // {
      //   text: "REASON",
      //   value: "comments",
      //   sortable: false,
      // },
      {
        text: "STATUS",
        value: "status_value",
        sortable: false,
      },
      {
        text: "ACTION",
        value: "action",
        sortable: false,
      },
    ],
    ApprRejuct: false,
    initiatedby: "",
    aapptitle: {},
    rejectss: "",
    approvess: "",
    search: "",
    searchint: "search by name , mobile number",
    error: false,
    fundingBalance: "",
    debitAmount: "",
    viewdetailsarray: [],
    arraylistStatus: false,
    urlArrry: [],
    image: [],
    urlimage: [],
    redcolor: "",
    corpcount: "",
    loadtype: "",
    checkaccessdata: {},
    loadType: "",
    Nodata: "",
    modalStart: false,
    modalEnd: false,
    start_date: null,
    end_date: null,
    itemsPerPage: 15,
    maxEndDate: null,
    currentDate: null,
    LoadCards: "",
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
  }),

  mounted() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.currentDate = moment().format("YYYY-MM-DD");
    this.maxEndDate = this.end_date;

    this.getcountNotification();
    this.checkaccess();
  },
  watch: {
    approve_amount(val) {
      if (Number(val) > this.commentsDetails.amount) {
        this.max_amount = `Enter Amount less than ${this.commentsDetails.amount}`;
        this.redcolor = "red";
        this.error = true;
      } else {
        //  console.log("true");
        this.max_amount = ``;
        this.redcolor = "";
        this.error = false;
      }
    },
    rejectss(val) {
      if (val == true) {
        this.approvess == true;
      }
    },
  },

  methods: {
    setMinMaxToDate() {
      let tempMaxDate = moment(this.start_date, "YYYY-MM-DD")
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.maxEndDate =
        this.currentDate < tempMaxDate ? this.currentDate : tempMaxDate;

      this.end_date = this.maxEndDate;
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDFUNDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getApporveHistory();
        this.getcountNotification();
      }
    },
    addfundtoaccount() {
      this.$router.push("/corporatefundrequest");
    },
    openinWindow(url) {
      window.open(url, "_blank");
    },
    openImageInNewTab(url) {
      //console.log("urlurl", url);
      this.urlArrry = [];
      this.urlArrry = url;
      // this.arraylistStatus = true;
      window.open(url, "_blank");
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log(responseData, "responseData");
      // if (responseData.data.data[0].module_code == "CARDFUNDS") {
      //   this.corpcount = responseData.data.data[0].count;
      //   this.$store.commit("SET_FundCount", this.corpcount);
      //   // console.log("corpcount", this.corpcount);
      // }
      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            // console.log("custcount", this.custcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
        }
      }
    },
    closedialog() {
      this.$refs.approveform.resetValidation();
      this.$refs.approveform.reset();
      this.showcommStatus = false;
    },

    verifyOtpApproval() {
      this.overlay = true;
      var optdemo =
        this.one + this.two + this.three + this.four + this.five + this.six;
      this.approveFunds("2", optdemo);
    },

    async approveFund() {
      if (this.$refs.approveform.validate()) {
        this.overlay = true;
        var inputData = {
          method_name: "CORPFUND",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "APORTAL",
          method_param: {
            action: "SENDOTP",
            fund_id: this.commentsDetails.fundid,
            phone_no: this.$store.getters.get_getCustDetails.mobile_num,
          },
        };

        // console.log(inputData);
        var responseData = await apiCall(inputData);

        if (responseData.data.status == "00") {
          this.otpReset();
          this.overlay = false;

          this.verifyOtpDialog = true;
        }
      }
    },

    confirmApproveRejectdialog() {
      if (this.$refs.approveform.validate()) {
        this.confirmApproveRejectDialog = true;
      }
    },

    async confirmApproveReject(status) {
      var inputData1 = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "APPROVE",
          fund_id: this.commentsDetails.fundid,
          logged_user_id: this.$store.getters.get_userid,
          approver_comments: this.approvercomment,
          status: status,
          approved_fund: this.rejectValue,
          type: this.loadType,
        },
      };
      this.overlay = true;
      var responseData = await apiCall(inputData1);
      //console.log("responseData", responseData);
      if (responseData.data.status == "00") {
        this.showcommStatus = false;
        this.verifyOtpDialog = false;
        this.confirmApproveRejectDialog = false;
        this.viewdetailsarray = [];
        this.getApporveHistory();
        this.overlay = false;

        this.$refs.approveform.resetValidation();
        this.$refs.approveform.reset();
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.getcountNotification();
        this.rejectValue = this.approve_amount;
      } else {
        this.overlay = false;
        this.$refs.approveform.resetValidation();
        this.$refs.approveform.reset();
        this.showcommStatus = false;
        this.confirmApproveRejectDialog = false;
        this.verifyOtpDialog = false;
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },

    async approveFunds(status, optdemo) {
      this.overlay = true;
      if (
        Number(this.approve_amount) < Number(this.commentsDetails.amount) &&
        Number(this.approve_amount) > 0
      ) {
        status = "5";
      } else if (Number(this.rejectValue == 0)) {
        status = "3";
      } else if (
        Number(this.approve_amount) == Number(this.commentsDetails.amount) &&
        Number(this.approve_amount) > 0 &&
        Number(this.approve_amount) != 0
      ) {
        status = "2";
      }
      var inputData1 = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "APPROVE",
          fund_id: this.commentsDetails.fundid,
          logged_user_id: this.$store.getters.get_userid,
          approver_comments: this.approvercomment,
          status: status,
          approved_fund:
            status == "2"
              ? this.approve_amount
              : status == "3"
              ? this.rejectValue
              : status == "5"
              ? this.approve_amount
              : "",
          otp_value: optdemo,
          type: this.loadType,
        },
      };
      this.overlay = true;
      var responseData = await apiCall(inputData1);
      //console.log("responseData", responseData);
      if (responseData.data.status == "00") {
        this.showcommStatus = false;
        this.verifyOtpDialog = false;
        this.confirmApproveRejectDialog = false;
        this.viewdetailsarray = [];
        this.getApporveHistory();
        this.overlay = false;

        this.$refs.approveform.resetValidation();
        this.$refs.approveform.reset();
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.getcountNotification();
        this.rejectValue = this.approve_amount;
      } else {
        this.overlay = false;
        this.$refs.approveform.resetValidation();
        this.$refs.approveform.reset();
        this.showcommStatus = false;
        this.confirmApproveRejectDialog = false;
        this.verifyOtpDialog = false;
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },

    getrequestAction(value) {
      this.ApprRejuct = true;
      this.aapptitle = value;
    },
    otpReset() {
      this.one = "";
      this.two = "";
      this.three = "";
      this.four = "";
      this.five = "";
      this.six = "";
    },
    showContent(value) {
      this.commentsDetails = value;
      this.initiatedon = this.commentsDetails.created_on;
      this.initiatedby = this.commentsDetails.fund_details.initiated_by;
      this.InitiatedFrom = this.commentsDetails.fund_details.initiated_from;
      this.otpReset();
      this.showcommStatus = true;
      this.loadType = value.load_type;

      this.urlimage = this.commentsDetails.receipt_urls;
      this.approve_amount = this.commentsDetails.amount;
      this.LoadCards = value.load_type == 1 ? "Load Card" : "Unload Card";
    },
    async getApporveHistoryPagination() {
      if (this.itemapprove.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        var inputData = {
          method_name: "CORPFUND",
          page_no: 1,
          record_count: 0,
          page_size: 0,
          app_code: "CPORTAL",
          method_param: {
            action: "GETREQFUNDS",
            search_text: this.search,
            status: "1",
            corp_id: this.$store.getters.get_corpid,
            load_type: this.cardtype,
            from_date: this.start_date,
            to_date: this.end_date,
          },
        };
        var responseData = await apiCall(inputData);

        this.itemapprove = this.itemapprove.concat(responseData.data.data);
      }
    },
    async getApporveHistory() {
      this.overlay = true;
      // this.loading = true;
      var inputData = {
        method_name: "CORPFUND",
        page_no: 1,
        record_count: 0,
        page_size: 0,
        app_code: "CPORTAL",
        method_param: {
          action: "GETREQFUNDS",
          search_text: this.search,
          status: "1",
          corp_id: this.$store.getters.get_corpid,
          load_type: this.cardtype,
          from_date: this.start_date,
          to_date: this.end_date,
        },
      };

      var responseData = await apiCall(inputData);
      this.overlay = false;
      if (responseData.data.status == "00") {
        this.itemapprove =
          responseData.data.data == null ? [] : responseData.data.data;
        this.totalCount = responseData.data.data[0].total_count;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.itemapprove = [];
      }

      // console.log("this.image", this.image);
      for (let i = 0; i < this.itemapprove.length; i++) {
        this.loadtype = this.itemapprove[i].load_type;
        // console.log("this.loadtype", this.loadtype);
        this.itemapprove[i].department_name =
          // console.log( this.loadtype)
          this.itemapprove[i].department_details.department_name;
        this.itemapprove[i].allocated_budget =
          this.itemapprove[i].department_details.allocated_budget;
        this.itemapprove[i].department_budget =
          this.itemapprove[i].department_details.department_budget;
        this.itemapprove[i].unallocated_budget =
          this.itemapprove[i].department_details.unallocated_budget;
        this.fundingBalance = this.itemapprove[i].corp_balance;
      }
      this.loading = false;
      this.showcommStatus = false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
input {
  margin: 0 5px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  outline: none;
  width: 10%;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;
}
.cursors {
  cursor: pointer;
}
</style>
